const XIcon = ({ color }) => {
  return (
    <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={color || "currentColor"}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.91346 13.0385L3.5 3H9L12.9808 9.23077L18 3H20L13.8654 10.6154L20.5 21H15L10.7981 14.4231L5.5 21H3.5L9.91346 13.0385ZM15.8217 19.5L6.23833 4.5H8.17833L17.7617 19.5H15.8217Z"
      />
    </svg>
  )
}

export default XIcon
